import React from 'react';
import Grid from '@material-ui/core/Grid';
import { ForgotPasswordForm } from '../components';
import Header from '../../../shared_elements/components/Header';

export default function ForgotPassword(props) {
  return (
    <section
      className="user-authentication-section"
      data-testid="forgotPassword"
    >
      <Header title="WELCOME TO THE CAMPAIGN REGISTRY"></Header>
      <Grid
        container
        spacing={0}
        alignItems="center"
        justify="center"
        className="user-form-wrapper"
      >
        <ForgotPasswordForm />
      </Grid>
    </section>
  );
}
